import type { TareaCrearInput, TareaEditarInput, TareaEstadisticasResponse, TareaPublic } from '@app/shared';

import { api } from '../../../lib/api';

// ciclo-tareas: gestión semanal de prioridades de Ailen.
export const tareasApi = {
  async listar(): Promise<TareaPublic[]> {
    const { data } = await api.get<{ tareas: TareaPublic[] }>('/tareas');
    return data.tareas;
  },

  async crear(input: TareaCrearInput): Promise<TareaPublic> {
    const { data } = await api.post<{ tarea: TareaPublic }>('/tareas', input);
    return data.tarea;
  },

  async editar(id: string, input: TareaEditarInput): Promise<TareaPublic> {
    const { data } = await api.patch<{ tarea: TareaPublic }>(`/tareas/${id}`, input);
    return data.tarea;
  },

  async eliminar(id: string): Promise<void> {
    await api.delete(`/tareas/${id}`);
  },

  async reordenar(ids: string[]): Promise<void> {
    await api.patch('/tareas/orden', { ids });
  },

  async estadisticas(): Promise<TareaEstadisticasResponse> {
    const { data } = await api.get<TareaEstadisticasResponse>('/tareas/estadisticas');
    return data;
  },
};
